import React from 'react';

const HeaderUserMenu = ({
    userMenuRef,
    isUserMenuOpen,
    setIsUserMenuOpen,
    currentUserEmail,
    currentUserName,
    currentUserInitials,
    tenantLogoUrl = '',
    activeTenantName = '',
    isAdmin,
    isDarkMode,
    setCurrentView,
    handleSignOut
}) => (
    <div ref={userMenuRef} className="relative shrink-0">
        <button
            type="button"
            onClick={() => setIsUserMenuOpen(prev => !prev)}
            className={`relative flex h-9 w-9 items-center justify-center overflow-hidden rounded-full border text-sm font-black transition-all ${isDarkMode ? 'border-[#404040] bg-[#292929] text-white hover:bg-[#404040]' : 'border-[#d8e0ea] bg-white text-[#172033] shadow-sm hover:bg-[#f1f5f9]'}`}
            title={currentUserEmail || 'Konto'}
            aria-label="Konto-Menü öffnen"
            aria-expanded={isUserMenuOpen}
        >
            <span>{currentUserInitials}</span>
            {tenantLogoUrl ? (
                <img
                    src={tenantLogoUrl}
                    alt={activeTenantName ? `${activeTenantName} Logo` : 'Mandanten-Logo'}
                    className="absolute inset-0 h-full w-full object-cover"
                    onError={(event) => {
                        event.currentTarget.style.display = 'none';
                    }}
                />
            ) : (
                <img
                    src="/profil.png"
                    alt=""
                    className="absolute inset-0 h-full w-full object-cover"
                    onError={(event) => {
                        event.currentTarget.style.display = 'none';
                    }}
                />
            )}
        </button>

        {isUserMenuOpen && (
            <div className={`absolute right-0 top-12 z-50 w-64 overflow-hidden rounded-2xl border shadow-xl ${isDarkMode ? 'border-[#404040] bg-[#292929]' : 'border-[#d8e0ea] bg-white'}`}>
                <div className={`border-b px-4 py-3 ${isDarkMode ? 'border-[#404040]' : 'border-slate-100'}`}>
                    <p className={`truncate text-sm font-black ${isDarkMode ? 'text-white' : 'text-slate-950'}`}>{currentUserName}</p>
                    {currentUserEmail && (
                        <p className={`mt-0.5 truncate text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>{currentUserEmail}</p>
                    )}
                </div>

                <div className="p-1.5">
                    <button
                        type="button"
                        onClick={() => {
                            setCurrentView('profile');
                            setIsUserMenuOpen(false);
                        }}
                        className={`w-full rounded-xl px-3 py-2 text-left text-sm font-semibold transition-colors ${isDarkMode ? 'text-slate-200 hover:bg-white/5' : 'text-slate-700 hover:bg-slate-50'}`}
                    >
                        Profil & Einstellungen
                    </button>
                    {isAdmin && (
                        <button
                            type="button"
                            onClick={() => {
                                setCurrentView('admin');
                                setIsUserMenuOpen(false);
                            }}
                            className={`w-full rounded-xl px-3 py-2 text-left text-sm font-semibold transition-colors ${isDarkMode ? 'text-slate-200 hover:bg-white/5' : 'text-slate-700 hover:bg-slate-50'}`}
                        >
                            Admin-Center
                        </button>
                    )}
                    <button
                        type="button"
                        onClick={handleSignOut}
                        className={`w-full rounded-xl px-3 py-2 text-left text-sm font-semibold transition-colors ${isDarkMode ? 'text-red-300 hover:bg-red-500/10' : 'text-red-600 hover:bg-red-50'}`}
                    >
                        Abmelden
                    </button>
                </div>
            </div>
        )}
    </div>
);

export default HeaderUserMenu;
